<template>
  <div id="login-form">
    <Form
      :header="header"
      :model="model"
      :schema="schema"
      :options="options"
      :buttons="buttons"
      :messages="messages"
      @form_submit="form_submit"
      @button_click="button_click"
    ></Form>
  </div>
</template>

<script>
import Vue from "vue";
import Form from "../../components/Form.vue";
import VueFormGenerator from "vue-form-generator";
import { get_validator_messages } from "../../validators/locale_pl";

var validator_messages = get_validator_messages();

export default {
  name: "Login",
  components: {
    Form
  },
  computed: {
    validation_email: function() {
      if (this.form.errors.email.length > 0) {
        return false;
      } else {
        return null;
      }
    }
  },
  data() {
    return {
      buttons: [
        {
          name: "login",
          style_classes: "float-right mb-1",
          buttons: [
            {
              label: "Zaloguj się",
              variant: "success",
              type: "submit",
              name: "login",
              icon: "shield-lock-fill",
              id: "login"
            }
          ]
        },
        {
          name: "other",
          style_classes: "float-right btn-group-sm mt-1",
          buttons: [
            {
              label: "Przypomnienie hasła",
              variant: "info",
              type: "button",
              name: "password-reset",
              icon: "lock-fill",
              id: "password-reset"
            },
            {
              label: "Nie mam konta",
              variant: "primary",
              type: "button",
              name: "register",
              icon: "person-plus-fill",
              id: "register"
            }
          ]
        }
      ],
      header: {
        title: "Logowanie",
        icon: "shield-lock-fill"
      },
      model: {
        email: null,
        password: null
      },
      messages: [],
      options: {
        validateAfterChanged: true,
        validateAsync: true
      },
      schema: {
        groups: [
          {
            styleClasses: "form-row",
            fields: [
              {
                styleClasses: "col-lg-12",
                type: "input",
                inputType: "email",
                label: "Email",
                model: "email",
                required: true,
                validator: [
                  VueFormGenerator.validators.email.locale(validator_messages),
                  VueFormGenerator.validators.required.locale(
                    validator_messages
                  )
                ]
              },
              {
                styleClasses: "col-lg-12",
                type: "input",
                inputType: "password",
                label: "Hasło",
                model: "password",
                required: true,
                autocomplete: true,
                validator: [
                  VueFormGenerator.validators.required.locale(
                    validator_messages
                  )
                ]
              }
            ]
          }
        ]
      }
    };
  },
  methods: {
    // This method is run when login form is submited
    // It gets model with all form data on it
    form_submit: function(model) {
      Vue.CognitoAuth.authenticate(
        model.email,
        model.password,
        this.login_success,
        this.login_failure
      );
    },
    login_success: function(result) {
      this.messages = [];
      var $this = this;
      Vue.CognitoAuth.get_user_data().then(function(data) {
        $this.$store.commit(
          "user_login",
          data,
          result.accessToken.jwtToken,
          result.refreshToken.token
        );
        $this.$router.push("/");
      });
    },
    login_failure: function(err) {
      console.log("login failure:", err);
      this.messages = [];
      this.messages.push({
        label: err,
        variant: "danger"
      });
    },
    button_click: function(button_name) {
      if (button_name == "register") {
        this.$router.push({ name: "Register" });
      } else if (button_name == "password-reset") {
        this.$router.push({ name: "PasswordReset" });
      }
    }
  },
  mounted() {
    this.$nextTick(function() {
      // check if previous action was successfull user registration
      var register_email = this.$localStorage.get("register_success");
      if (register_email) {
        this.messages = [
          {
            variant: "success",
            label: "Twój adres email został zweryfikowany prawidłowo."
          },
          {
            variant: "primary",
            label: "Możesz się zalogować."
          }
        ];
        this.model.email = register_email;
        this.$localStorage.remove("register_success");
      }

      var password_reset = this.$localStorage.get("password_reset_email");
      if (password_reset) {
        this.messages = [
          {
            variant: "success",
            label: "Możesz się zalogować używając nowego hasła."
          }
        ];
        this.$localStorage.remove("password_reset_email");
      }
    });
  }
};
</script>

<style>
@media (min-width: 768px) {
  #login-form .form-container {
    max-width: 520px;
  }
}
</style>
